import { render, staticRenderFns } from "./userOkrUpdate.vue?vue&type=template&id=48f80af7"
import script from "./userOkrUpdate.vue?vue&type=script&lang=js"
export * from "./userOkrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports